import WithSidebar from 'Layout/WithSidebar';
import { relatedProductPageTitles } from 'components/NavigationSideBar/mockData';
import image from 'images/small-images-inside-text/wuxal.jpg';
import formulaImage from 'images/info-image-2.jpg';
import formulaImageMobile from 'images/formula-mobile.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItemsBox from 'components/ProductItemsBox';
import { products, tabsData, vegetables } from 'components/ProductItems/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { Button } from 'components/buttons/Button/Button';
import BenefitsBox from 'components/BenefitsBox';
import NavigationSideBar from 'components/NavigationSideBar';
import { data2 } from 'components/BenefitsBox/mockData';
import ProductItemsBoxWithTabs from 'components/ProductItemsBox/ProductItemsBoxWithTabs';
import PictureComponent from 'components/PictureComponent';
import Banner from 'components/Banner';
import relatedProductBanner from 'images/relatedProductBanner.jpg';
import PDFBox from 'components/PDFBox';
import { relatedProductFiles } from 'components/PDFBox/mockData';
import { CTAFormSection } from 'components/formSections/CTAFormSection';
import React from 'react';
import useOnScreen, { range } from 'hooks/useOnScreen';

const RelatedProduct = () => {
    const sectionRef1 = React.useRef(null);
    const sectionRef2 = React.useRef(null);
    const sectionRef6 = React.useRef(null);
    const options = { threshold: range(0, 1, 0.01, 2) };

    const { ratio: ratio1 } = useOnScreen(sectionRef1, { ...options });
    const { ratio: ratio2 } = useOnScreen(sectionRef2, { ...options });
    const { ratio: ratio6 } = useOnScreen(sectionRef6, { ...options });

    // const [activeSectionIndex, setActiveSectionIndex] = React.useState(0);
    console.log({
        ratio1,
        ratio2,
        ratio6,
    });

    const calcIndex = () => {
        let index = 1;

        if (ratio1 > 0) {
            console.log('ratio1 > 0');
            index = 1;
        }
        if (ratio2 > 0) {
            console.log('ratio2 > 0');
            index = 2;
        }
        if (ratio6 > 0) {
            console.log('ratio6 > 0');
            index = 6;
        }

        return index - 1;
    };

    // const handleScroll = event => {

    //     setActiveSectionIndex(index - 1);
    // };

    // React.useEffect(() => {
    //     window.addEventListener('scroll', handleScroll);

    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    return (
        <div className="container">
            <Banner
                title="Our products"
                image={relatedProductBanner}
                buttonText="FIND A DISTRIBUTOR"
                buttonType="banner"
            />
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>about product</LabelButton>
                    <GradientText>
                        Highly concentrated <br /> suspension of
                        <img src={image} alt="decor" />
                        <em>Wuxal P Max New</em>
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="super-small">
                            Highly concentrated suspension with a high content of phosphorus and zinc, which has
                            <em>
                                the properties of a water conditioner, anti evaporation agent and viscous sludge
                                reactor.
                            </em>
                        </GradientText>
                    </div>
                </div>
                {/* <div className="outer" ref={outerRef}>
                    <div className="inner" style={{ height }}>
                        <p
                            style={{
                                opacity: ratio / 100 - 0.1,
                                transform: ratio > 90 ? 'scale(1.25)' : 'none',
                            }}
                        >
                            Follow You!
                        </p>
                    </div>
                </div> */}
                <WithSidebar
                    Sidebar={
                        <NavigationSideBar activeIndex={calcIndex()} items={relatedProductPageTitles} offset={780} />
                    }
                >
                    <div ref={sectionRef1}>
                        <GeneralInfoBox>
                            <h3>General information</h3>
                            <p>
                                Wuxal Р Мах is ideal for promoting the growth and development of the root system of
                                plants in the early stages of vegetation, as well as for reducing plant stress caused by
                                phosphorus or zinc deficiency.
                            </p>
                            <p>
                                The phosphorus in Wuxal Р Мах is in the form of water-soluble phosphate, which
                                guarantees fast and safe phosphorus supply to plants. It also contains nitrogen, which
                                promotes plant growth.
                            </p>
                            <p>
                                Wuxal Р Мах has the best buffering properties and neutralizes the pH of the working
                                solution, which guarantees the optimal effect of plant protection products.
                            </p>
                            <p>
                                Wuxal has been known on the Ukrainian market since 2003 and has gained a reputation as a
                                high-quality, effective and reliable means of increasing crop productivity. The
                                technologies implemented in Wuxal are one step ahead of modern cultivation technologies.
                            </p>
                            <Button type="read-more">READ MORE</Button>
                        </GeneralInfoBox>
                    </div>
                    <div ref={sectionRef2}>
                        <PictureComponent srcBig={formulaImage} srcSmall={formulaImageMobile} alt="formula" />
                    </div>
                    <BenefitsBox title="Benefits" data={data2} />
                    <PDFBox title="Technical information" data={relatedProductFiles} />
                    <ProductItemsBoxWithTabs title="Trial results" data={tabsData} />
                    <div ref={sectionRef6}>
                        <ProductItemsBox title="Crop nutrition programs" data={vegetables} />
                    </div>
                    <ProductItemsBox title="Related products" data={products} />
                </WithSidebar>
            </div>
            <CTAFormSection />
        </div>
    );
};

export default RelatedProduct;
